import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import Link from "next/link";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GuidelineAgreementModal = props => {
  return /*#__PURE__*/_jsxs("div", {
    className: modalStyles.container,
    children: [/*#__PURE__*/_jsx("header", {
      children: /*#__PURE__*/_jsx("h2", {
        children: "\u30B3\u30E1\u30F3\u30C8\u6295\u7A3F\u6642\u306E\u7559\u610F\u70B9"
      })
    }), /*#__PURE__*/_jsxs("p", {
      className: modalStyles.guideLineText,
      children: ["\u3054\u5229\u7528\u306B\u3042\u305F\u3063\u3066\u306F", /*#__PURE__*/_jsx(Link, {
        className: modalStyles.linkText,
        href: "/static/legal/chat_guideline/",
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3"
      }), "\u306B\u540C\u610F\u306E\u4E0A\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002"]
    }), /*#__PURE__*/_jsx(Button, {
      fillWhiteColor: true,
      fontFixed: true,
      large: true,
      fontBold: true,
      onClick: props.handleClick,
      children: "\u540C\u610F\u306E\u4E0A\u3067\u53C2\u52A0\u3059\u308B"
    }), /*#__PURE__*/_jsx(Button, {
      fontFixed: true,
      large: true,
      onClick: props.modalAndComponentCloseHandle,
      borderLight: true,
      children: "\u9589\u3058\u308B"
    })]
  });
};
export default GuidelineAgreementModal;